<div class="container py-5 text-center">
  <div class="card shadow-sm p-4">
    <h3 class="text-danger mb-3">
      <i class="bi bi-exclamation-triangle-fill"></i> Confirmar eliminación
    </h3>
    <p class="mb-4">
      ¿Estás seguro de que deseas eliminar el artículo con código 
      <strong>{{ codigo }}</strong>? Esta acción no se puede deshacer.
    </p>

    <div class="d-flex justify-content-center gap-3">
      <button class="btn btn-outline-secondary btn-lg" (click)="onCancel()">Cancelar</button>
      <button class="btn btn-danger btn-lg" (click)="onConfirmDelete()" [disabled]="loading()">
        @if (loading()) { Eliminando... } @else { Eliminar }
      </button>
    </div>

    @if (success()) {
      <div class="alert alert-success mt-4">
        <i class="bi bi-check-circle-fill"></i> Artículo eliminado correctamente.
      </div>
    }

    @if (error()) {
      <div class="alert alert-danger mt-4">
        <i class="bi bi-x-circle-fill"></i> {{ error() }}
      </div>
    }
  </div>
</div>
